export default class QueryParameterService {
  static get(key: string): string | undefined {
    const result = new URLSearchParams(window.location.search).get(key)
    return result === null ? undefined : result
  }
}
